module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.css
// module id = ./src/app/layout/layout.component.css
// module chunks = main